/** Shared form validation utilities */

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Returns CSS classes for a field based on error/valid state */
export function fieldClass(base, showError, isValid) {
  if (showError) return `${base} border-red-400 bg-red-50 focus:border-red-500 focus:ring-red-200`;
  if (isValid)   return `${base} border-green-400 bg-green-50 focus:border-green-500`;
  return base;
}

/** Same but for portal inputs (no wit-input base, inline Tailwind) */
export function portalFieldClass(showError, isValid) {
  const base = "w-full border rounded-2xl py-3.5 focus:outline-none transition-colors";
  if (showError) return `${base} border-red-400 bg-red-50 text-cocoa pl-11 pr-5 focus:border-red-400`;
  if (isValid)   return `${base} border-green-400 bg-green-50 text-cocoa pl-11 pr-5 focus:border-green-500`;
  return `${base} bg-porcelain border-sandBeige text-cocoa pl-11 pr-5 focus:border-raspberry`;
}
